import { Injectable } from '@angular/core';

@Injectable()
export class AuthContextService {

  constructor() { }

  public getToken(): string{
    return (localStorage.getItem('auth_token'));
  }

}



// WEBPACK FOOTER //
// ./src/app/auth-context.service.ts